import React, {Suspense} from 'react'
import PicCont from './PicCont';
import riser from '../public/Pictures/stage-riser.png'
import { useDispatch } from 'react-redux';
import { SHOW_POPUP } from '../store/slices/ui';
import dynamic from 'next/dynamic'
import StageBuilder from './StageBuilder';
import VideoWallBuilder from './VideoWallBuilder';
import { Spinner } from './Components';
import { FaCalendarCheck } from "@react-icons/all-files/fa/FaCalendarCheck";
import { FaFileInvoiceDollar } from "@react-icons/all-files/fa/FaFileInvoiceDollar";
import { FaShoppingCart } from "@react-icons/all-files/fa/FaShoppingCart";
import { BsArrowRight } from "@react-icons/all-files/bs/BsArrowRight";
import { GiChoice } from "@react-icons/all-files/gi/GiChoice";
import { FaRulerCombined } from "@react-icons/all-files/fa/FaRulerCombined";
import { FaTruck } from "@react-icons/all-files/fa/FaTruck";
import { FaWrench } from "@react-icons/all-files/fa/FaWrench";
import * as gtag from '../lib/gtag'
import stagebuilder from '../public/Pictures/stagebuilder.gif'
import vwgif from '../public/Pictures/vwgif.gif'
import emptylaptop from '../public/Pictures/emptylaptop.png'
import { useRouter } from 'next/router';
import { marketFromPath } from '../utilities/fulfillmentMarket';
import Action from './design-system/primitives/Action';
import UiBoundary from './design-system/foundations/UiBoundary';

export const openStageBuilderPopup = ({ dispatch, videowall = false }) => {
  dispatch(SHOW_POPUP({
    size: 'xxl',
    key: 'stageBuilder',
    trapFocus: true,
    ariaLabelledBy: videowall ? 'video-wall-builder-dialog-title' : 'stage-builder-dialog-title',
    onClose: () => gtag.event({ action: 'builder_abandoned', label: videowall ? 'video_wall' : 'stage', value: 0, category: 'orders' }),
    body: <Suspense fallback={<Spinner size='tiny' />}>{videowall ? <VideoWallBuilder /> : <StageBuilder />}</Suspense>
  }))
}

const StageBuilderComp = ({title, fromPackage, videowall, _orlando, catalogHref = '#bundles'}) => {
    let dispatch= useDispatch()
    let {pathname} = useRouter()
    let orlando = _orlando || marketFromPath(pathname) === 'Orlando'

  return <UiBoundary className={`stageBuilderCompNew ${fromPackage? 'fromPackage' : ''}`}>

    <div className="box">
    <div className='upperBold'>{videowall ? "Click to configure your LED Video Wall Rental!" :"Click to configure the size of the stage for your next event!"}</div>

      <div className="buttons">
        <Action icon={FaRulerCombined} onClick={() => openStageBuilderPopup({ dispatch, videowall })}>
          {videowall ? 'Configure Video Wall' : 'Configure Stage'}
        </Action>
    </div>
    </div>
{!fromPackage &&    <div className="laptopCont">
    <div className='back'></div>
    <PicCont className='gif' width={566} height={474} src={videowall ?vwgif :stagebuilder} />

    <PicCont className='laptop' width={960} height={690} src={emptylaptop} />
    </div>}

  {!fromPackage &&  <div className="titleBox">
      <h4 className='bold'>Looking to rent a {videowall ? 'led wall' :'stage'} in {orlando ? 'Orlando' :'Miami'}?</h4>
      {videowall ?
           <p>Use our <span className='thick'>online video wall configuration tool</span> to compare LED walls for concerts, conferences, sporting events, fashion shows and houses of worship.<br /><br />
           You can also choose from our pre-made <a href={catalogHref}>LED wall bundles</a>. Navigate the catalog by selecting <span className='thick sinppetText' style={{color: 'green'}}>Resolution</span> (number of pixels per side), <span className='thick sinppetText' style={{color: 'darkGoldenRod'}}>Screen Area</span>, <span className='thick sinppetText' style={{color: 'darkSlateBlue'}}>Pitch</span> (distance between pixels), <span className='thick'>Price</span>, and more.</p>
    :
    <p>Use our <span className='thick'>online stage configuration tool</span> to choose a modular stage footprint and height for presentations, bands, weddings, runways and outdoor programs. We deliver and assemble the selected stage at your venue.<br /><br />
    Prefer a ready-made option? Compare <a href={catalogHref}>stage packages</a> by <span className='thick sinppetText' style={{color: 'darkSlateBlue'}}>Height</span>, <span className='thick sinppetText' style={{color: 'green'}}>Stage Capacity</span>, <span className='thick sinppetText' style={{color: 'darkGoldenRod'}}>Area</span>, <span className='thick'>Price</span>, and more.</p>
    }

    </div>}




  </UiBoundary>
}

export default StageBuilderComp
